import { useEffect, useState } from "react";
import {
  Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle,
  FormControlLabel, IconButton, Radio, RadioGroup, Stack, TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { useLanguage } from "../../i18n/LanguageContext";

const empty = { name: "", description: "", fullDayOnly: false };

export default function AreaDialog({ open, initial, onClose, onSave }) {
  const { t } = useLanguage();
  const [form, setForm] = useState(initial || empty);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) setForm(initial || empty);
  }, [initial, open]);

  const handleSubmit = () => {
    if (!form.name.trim()) {
      setError(t("areas.errNoName"));
      return;
    }
    setError("");
    onSave(form);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        {initial ? t("areas.editArea") : t("areas.addArea")}
        <IconButton onClick={onClose} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <TextField
            label={t("areas.name")}
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            fullWidth
            autoFocus
          />
          <TextField
            label={t("areas.description")}
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
            fullWidth
            multiline
            minRows={2}
          />
          <RadioGroup
            value={form.fullDayOnly ? "day" : "hours"}
            onChange={(e) => setForm({ ...form, fullDayOnly: e.target.value === "day" })}
          >
            <FormControlLabel value="hours" control={<Radio size="small" />} label={t("areas.modeHours")} />
            <FormControlLabel value="day" control={<Radio size="small" />} label={t("areas.modeFullDay")} />
          </RadioGroup>
        </Stack>
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose}>{t("common.cancel")}</Button>
        <Button variant="contained" startIcon={<CheckIcon />} onClick={handleSubmit}>
          {t("common.save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
